import { createFileRoute } from '@tanstack/react-router'

import { CustomerPageWrapper } from '@/components/molecules/customer-page-wrapper'
import PageHeader from '@/components/molecules/shared/page-header'
import { AccountingGeneralLedger } from '@/features/accounting/pages/general-ledger'
import Head from '@/lib/navigation/head'

function GeneralLedgerRoute() {
  return (
    <>
      <Head>
        <title>General ledger | Nonresident Tax</title>
      </Head>
      <CustomerPageWrapper stickyHeader={<PageHeader title="General ledger" sticky />}>
        <AccountingGeneralLedger />
      </CustomerPageWrapper>
    </>
  )
}

export const Route = createFileRoute('/_shell/accounting/general-ledger')({
  component: GeneralLedgerRoute,
})
